<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventManagers"
        title-table="Responsáveis por Evento"
        module="eventManagerSettingsModule"
        sort-name="responsavel.nome"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <EventManagerForm v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import EventManagerForm from "./form/EventManagerForm.vue";

export default {
  name: "EventManagerSetting",
  components: {
    BRow,
    BCol,
    TableComponents,
    EventManagerForm,
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: "ID",
          field: "id",
          width: "80px",
        },
        {
          label: "Evento",
          field: "evento.nome",
        },
        {
          label: "Responsável",
          field: "responsavel.nome",
        },
        {
          label: "Ativo",
          field: "ativo",
          formatter: (value) => (value ? "Sim" : "Não"),
          width: "80px",
        },
      ],
    };
  },
  computed: {
    ...mapState("eventManagerSettingsModule", {
      listaEventManagers: (state) => state.listaEventManagers,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch("eventManagerSettingsModule/reset");
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("eventManagerSettingsModule/prepareToEdit", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
      this.$store.dispatch("eventManagerSettingsModule/reset");
    },
  },
};
</script>
